import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Radio } from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { updateExpert } from "../../../service/api";

function Others(expertData) {
  const [visitInfo, setVisitInfo] = useState(expertData?.expertData?.expert?.willingMakeVisit);
  const [show, setShow] = useState(expertData?.expertData?.expert?.hasVehicle);
  const queryClient = useQueryClient();
  const mutation = useMutation(updateExpert, {
    onSuccess: () => {
      queryClient.invalidateQueries(["expertData"]);
    },
  });

  const notWillingtoVisit = (e) => {
    setShow(false);
    mutation.mutate({ willingMakeVisit: e.target.value });
  };
useEffect(()=>{
  if(visitInfo?.hasOwnProperty("hasVehicle")){

    mutation.mutate(visitInfo);
  }
},[visitInfo])
  return (
    <div className="bg-white rounded-2xl p-6 flex flex-col gap-2 w-full ">
      <h2 className="text-right font-body text-2xl font-bold text-[#005AC7] max-lg:text-[0.875rem]">
        سایر اطلاعات
      </h2>
      <section className="flex  font-body justify-between max-lg:flex-col max-lg:m-auto">
        <div layout="vertical">
          <div className="flex flex-wrap gap-4 items-start    w-[60vw] max-lg:w-full">
            <div
              required
              className="w-[30vw]  max-lg:w-full flex flex-col items-center gap-4"
            >
              <label>
                آیا علاوه بر کارشناسی به فعالیت کشاورزی نیز مشغول هستید؟
              </label>
              <Radio.Group
                onChange={(e) =>
                  mutation.mutate({ agriculturalActivity: e.target.value })
                }
                className="w-[30vw]"
                defaultValue={
                  expertData?.expertData?.expert?.agriculturalActivity
                }
              >
                <Radio value={true}>بله</Radio>
                <Radio value={false}>خیر</Radio>
              </Radio.Group>
            </div>
            <div
              required
              className="w-[30vw] max-lg:w-full flex flex-col items-center gap-4"
            >
              <label>
                آیا تمایل به انجام بازدید حضوری با دریافت هزینه برای کشاورزان
                دارید؟
              </label>
              <Radio.Group
              defaultValue={visitInfo}
                onChange={(e) => {
                  setVisitInfo({ willingMakeVisit: e.target.value });
                  e.target.value === false ? notWillingtoVisit(e) : setShow(true);
                }}
                
              >
                <Radio value={true}>بله</Radio>
                <Radio value={false}>خیر</Radio>
              </Radio.Group>
            </div>

            {show && (
              <div
                required
                className="w-[20vw] max-lg:w-full flex flex-col items-center gap-4"
              >
                <label>برای انجام بازدید وسیله نقلیه دارید؟</label>
                <Radio.Group
                defaultValue={show}
                  onChange={(e) => {
                    setVisitInfo({ ...visitInfo, hasVehicle: e.target.value });
                    
                  }}
                  
                >
                  <Radio value={true}>بله</Radio>
                  <Radio value={false}>خیر</Radio>
                </Radio.Group>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Others;
